import React from 'react';
import { useIntl } from 'react-intl';
import { useRegistration } from '@/hooks/useRegistration';
import { GTagEvents, OpenedFrom, triggerGTag } from '@/lib/gTagManager';

export function FreeToPlayBanner(): JSX.Element {
  const intl = useIntl();
  const { openRegistration } = useRegistration();

  return (
    <div className="fixed bottom-[calc(57px+var(--safe-area-inset-bottom,0px))] left-0 right-0 z-[89] flex items-center justify-center bg-blue3 px-4 py-2 text-sm text-white md:hidden">
      <span>
        {intl.formatMessage({ id: 'game.freeToPlay.text' })}{' '}
        <button
          type="button"
          className="font-bold text-blue-light underline"
          onClick={() => {
            triggerGTag(GTagEvents.f2p_banner_register);
            openRegistration({ openedFrom: OpenedFrom.Game });
          }}
        >
          {intl.formatMessage({ id: 'game.freeToPlay.cta' })}
        </button>
      </span>
    </div>
  );
}
